<template>
  <button @click="swiper.slideNext()" class="btn-onboarding">Next</button>
</template>
<script>
import { defineComponent } from "vue";
import { useSwiper } from "swiper/vue";

export default defineComponent({
  components: {},
  setup() {
    const swiper = useSwiper();

    return {
      swiper,
    };
  },
});
</script>
